import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { LoadingIndicator } from '@shared/components/loading';
import { useChannel } from '@shared/util/hooks';
import { CardChannelContext } from './CardChannelContext';

interface Props {
  channelSlug: string;
  children: ReactNode;
}

export function CardChannelProvider({ channelSlug, children }: Props) {
  const channel = useChannel({ channelSlug });
  if (isNil(channel)) {
    return <LoadingIndicator fill />;
  }

  return <CardChannelContext.Provider value={channel}>{children}</CardChannelContext.Provider>;
}
